/**
 * Капсула-кнопка (pill button): тот же стиль, что и Pill, но кликабельная. Стили из ui/tokens.
 */

import { soundManager } from '../../services/SoundManager';

export interface PillButtonOptions {
  icon?: string;
  text: string;
  onClick: () => void;
  ariaLabel?: string;
}

export function createPillButton(options: PillButtonOptions): HTMLButtonElement {
  const { icon, text, onClick, ariaLabel } = options;
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ui-pill-btn';
  if (ariaLabel) btn.setAttribute('aria-label', ariaLabel);

  if (icon !== undefined) {
    const iconEl = document.createElement('span');
    iconEl.className = 'ui-pill-btn-icon';
    iconEl.setAttribute('aria-hidden', 'true');
    iconEl.textContent = icon;
    btn.appendChild(iconEl);
  }
  const textEl = document.createElement('span');
  textEl.className = 'ui-pill-btn-text';
  textEl.textContent = text;
  btn.appendChild(textEl);

  btn.addEventListener('click', () => {
    soundManager.playClick();
    onClick();
  });
  return btn;
}
